module.exports = __webpack_public_path__ + "static/media/grades.5bab57ca.xlsx";